import { controls, grouped } from "../controls";
const roles = {
  label: "Roles",
  pageLabel: "Roles", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: true } },
  pageType: "history",
  formTabs:
  {
    allTabs: [
      { label: "General", uid: "general" },
      { label: "Role Limits", uid: "role_limits", fastpath: "limits" },
      { label: "Role Dashboards", uid: "role_dashboards", fastpath: "role_dashboards" },
      { label: "Role Favourites", uid: "role_favourites", fastpath: "role_favourites" },
      { label: "Role Authentications", uid: "role_authentications", fastpath: "authentication_requireds" },
      { label: "Portal Access", uid: "role_portals", fastpath: "role_portals" },
      { label: "Role Form Groups", uid: "role_form_groups", fastpath: "role_form_groups" }
    ]
  },
  filter: [
    ...controls.displayText({ tab: "filter", label: "Code" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "role_code", maxlength: 50 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Description" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "role_display", maxlength: 50 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
  ]
  , form: [
    ...controls.displayText({ tab: "general", label: "Code", star: true }),
    ...controls.text({ tab: "general", placeHolder: "", name: "role_code", isRequired: true, maxlength: 50 }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.displayText({ tab: "general", label: "Description", star: true }),
    ...controls.text({ tab: "general", placeHolder: "", name: "role_display", isRequired: true, maxlength: 50 }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.displayText({ tab: "general", label: "Role Level", star: false }),
    ...controls.numberOnly({ tab: "general", placeHolder: "", name: "role_level", maxlength: 200 }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.displayText({ tab: "role_limits", label: "Start Dow", star: false }),
    ...controls.numberOnly({ tab: "role_limits", placeHolder: "", name: "start_dow", maxlength: 200 }),
    ...controls.displayText({ tab: "role_limits", label: "" }),
    ...controls.displayText({ tab: "role_limits", label: "End Dow", star: false }),
    ...controls.numberOnly({ tab: "role_limits", placeHolder: "", name: "end_dow", maxlength: 200 }),
    ...controls.displayText({ tab: "role_limits", label: "" }),
    ...controls.displayText({ tab: "role_limits", label: "Start Dom", star: false }),
    ...controls.numberOnly({ tab: "role_limits", placeHolder: "", name: "start_dom", maxlength: 200 }),
    ...controls.displayText({ tab: "role_limits", label: "" }),
    ...controls.displayText({ tab: "role_limits", label: "End Dom", star: false }),
    ...controls.numberOnly({ tab: "role_limits", placeHolder: "", name: "end_dom", maxlength: 200 }),
    ...controls.displayText({ tab: "role_limits", label: "" }),
    ...controls.displayText({ tab: "role_limits", label: "Start Month", star: false }),
    ...controls.numberOnly({ tab: "role_limits", placeHolder: "", name: "start_month", maxlength: 200 }),
    ...controls.displayText({ tab: "role_limits", label: "" }),
    ...controls.displayText({ tab: "role_limits", label: "End Month", star: false }),
    ...controls.numberOnly({ tab: "role_limits", placeHolder: "", name: "end_month", maxlength: 200 }),
    ...controls.displayText({ tab: "role_limits", label: "" }),
    ...controls.displayText({ tab: "role_limits", label: "From Time", star: false }),
    ...controls.text({ tab: "role_limits", placeHolder: "", name: "from_time", maxlength: 50 }),
    ...controls.displayText({ tab: "role_limits", label: "" }),
    ...controls.displayText({ tab: "role_limits", label: "To Time", star: false }),
    ...controls.text({ tab: "role_limits", placeHolder: "", name: "to_time", maxlength: 50 }),
    ...controls.displayText({ tab: "role_limits", label: "" }),
    ...controls.displayText({ tab: "role_limits", label: "Transaction Type", star: false }),
    ...controls.oc({ tab: "role_limits", c: "TransactionType", placeHolder: "Transaction Type Code", name: "transaction_type_code", fastpath: "transaction_types", hidden: false }),
    ...controls.showData({ tab: "role_limits", displaytype: "capital", data: "transaction_type_display" }),
    ...controls.displayText({ tab: "role_limits", label: "Amount" }),
    ...controls.floatOnly({ tab: "role_limits", placeHolder: "", name: "amount", maxlength: 16 }),
    ...controls.displayText({ tab: "role_limits", label: "" }),
    ...controls.displayText({ tab: "role_limits", label: "Frequency", star: false }),
    ...controls.numberOnly({ tab: "role_limits", placeHolder: "", name: "frequency", maxlength: 200 }),
    ...controls.displayText({ tab: "role_limits", label: "" }),
    ...controls.displayText({ tab: "role_limits", label: "Form", star: false }),
    ...controls.oc({ tab: "role_limits", c: "Form", placeHolder: "Form Code", name: "form_code", fastpath: "forms", hidden: false }),
    ...controls.showData({ tab: "role_limits", displaytype: "capital", data: "form_display" }),
    ...controls.checkBox({ tab: "role_limits", label: "Can Create New", default: false, name: "can_create_new" }),
    ...controls.checkBox({ tab: "role_limits", label: "Can Update", default: false, name: "can_update" }),
    ...controls.checkBox({ tab: "role_limits", label: "Disable Gui Update", default: false, name: "disable_gui_update" }),
    ...controls.checkBox({ tab: "role_limits", label: "Can Delete", default: false, name: "can_delete" }),
    ...controls.checkBox({ tab: "role_limits", label: "Can Auth", default: false, name: "can_auth" }),
    ...controls.checkBox({ tab: "role_limits", label: "Can Print", default: false, name: "can_print" }),
    ...controls.checkBox({ tab: "role_limits", label: "Can Export", default: false, name: "can_export" }),
    ...controls.checkBox({ tab: "role_limits", label: "Can Share", default: false, name: "can_share" }),
    ...controls.checkBox({ tab: "role_limits", label: "Is Lifetime Limit", default: false, name: "is_lifetime_limit" }),

    ...controls.displayText({ tab: "role_limits", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "role_limits", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "role_limits",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "role_limits",
        requiredField: ["start_dow", "end_dow", "start_dom", "end_dom", "start_month", "end_month", "from_time", "to_time", "transaction_type_code", "transaction_type_display", "transaction_type_uid", "amount", "frequency", "form_code", "form_display", "form_uid", "can_create_new", "can_update", "disable_gui_update", "can_delete", "can_auth", "can_print", "can_export", "can_share", "is_lifetime_limit",],
        required: [],
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "role_limits",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "role_limits",
        requiredField: ["start_dow", "end_dow", "start_dom", "end_dom", "start_month", "end_month", "from_time", "to_time", "transaction_type_code", "transaction_type_display", "transaction_type_uid", "amount", "frequency", "form_code", "form_display", "form_uid", "can_create_new", "can_update", "disable_gui_update", "can_delete", "can_auth", "can_print", "can_export", "can_share", "is_lifetime_limit",]
      }, width: "col-sm-2"
    }),
    {
      tab: "role_limits",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Start Dow", field: "start_dow" },
        { label: "End Dow", field: "end_dow" },
        { label: "Start Dom", field: "start_dom" },
        { label: "End Dom", field: "end_dom" },
        { label: "Start Month", field: "start_month" },
        { label: "End Month", field: "end_month" },
        { label: "From Time", field: "from_time" },
        { label: "To Time", field: "to_time" },
        { label: "Transaction Type Code", field: "transaction_type_code" },
        { label: "Transaction Type ", field: "transaction_type_display" },
        { label: "Amount", field: "amount" },
        { label: "Frequency", field: "frequency" },
        { label: "Form Code", field: "form_code" },
        { label: "Form ", field: "form_display" },
        { label: "Can Create New", field: "can_create_new", displaytype: "tick" },
        { label: "Can Update", field: "can_update", displaytype: "tick" },
        { label: "Disable Gui Update", field: "disable_gui_update", displaytype: "tick" },
        { label: "Can Delete", field: "can_delete", displaytype: "tick" },
        { label: "Can Auth", field: "can_auth", displaytype: "tick" },
        { label: "Can Print", field: "can_print", displaytype: "tick" },
        { label: "Can Export", field: "can_export", displaytype: "tick" },
        { label: "Can Share", field: "can_share", displaytype: "tick" },
        { label: "Is Lifetime Limit", field: "is_lifetime_limit", displaytype: "tick" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "role_limits"
    },
    ...controls.displayText({ tab: "role_dashboards", label: "Dashboard", star: false }),
    ...controls.oc({ tab: "role_dashboards", c: "Dashboard", placeHolder: "Dashboard Code", name: "dashboard_code", fastpath: "dashboards", hidden: false }),
    ...controls.showData({ tab: "role_dashboards", displaytype: "capital", data: "dashboard_display" }),
    ...controls.displayText({ tab: "role_dashboards", label: "Portal", star: false }),
    ...controls.oc({ tab: "role_dashboards", c: "Portal", placeHolder: "Portal Code", name: "portal_code", fastpath: "portals", hidden: false }),
    ...controls.showData({ tab: "role_dashboards", displaytype: "capital", data: "portal_display" }),
    ...controls.displayText({ tab: "role_dashboards", label: "Sequence", star: false }),
    ...controls.numberOnly({ tab: "role_dashboards", placeHolder: "", name: "sequence", maxlength: 200 }),
    ...controls.displayText({ tab: "role_dashboards", label: "" }),

    ...controls.displayText({ tab: "role_dashboards", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "role_dashboards", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "role_dashboards",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "role_dashboards",
        requiredField: ["dashboard_code", "dashboard_display", "dashboard_uid", "portal_code", "portal_display", "portal_uid", "sequence",],
        required: [],
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "role_dashboards",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "role_dashboards",
        requiredField: ["dashboard_code", "dashboard_display", "dashboard_uid", "portal_code", "portal_display", "portal_uid", "sequence",]
      }, width: "col-sm-2"
    }),
    {
      tab: "role_dashboards",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Dashboard Code", field: "dashboard_code" },
        { label: "Dashboard ", field: "dashboard_display" },
        { label: "Portal Code", field: "portal_code" },
        { label: "Portal ", field: "portal_display" },
        { label: "Sequence", field: "sequence" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "role_dashboards"
    },
    ...controls.displayText({ tab: "role_favourites", label: "Sequence", star: false }),
    ...controls.numberOnly({ tab: "role_favourites", placeHolder: "", name: "sequence", maxlength: 200 }),
    ...controls.displayText({ tab: "role_favourites", label: "" }),
    ...controls.displayText({ tab: "role_favourites", label: "Form", star: false }),
    ...controls.oc({ tab: "role_favourites", c: "Form", placeHolder: "Form Code", name: "form_code", fastpath: "forms", hidden: false }),
    ...controls.showData({ tab: "role_favourites", displaytype: "capital", data: "form_display" }),
    ...controls.displayText({ tab: "role_favourites", label: "Label", star: false }),
    ...controls.text({ tab: "role_favourites", placeHolder: "", name: "label", width: "col-sm-4", maxlength: 100 }),
    ...controls.displayText({ tab: "role_favourites", label: "Portal", star: false }),
    ...controls.oc({ tab: "role_favourites", c: "Portal", placeHolder: "Portal Code", name: "portal_code", fastpath: "portals", hidden: false }),
    ...controls.showData({ tab: "role_favourites", displaytype: "capital", data: "portal_display" }),

    ...controls.displayText({ tab: "role_favourites", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "role_favourites", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "role_favourites",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "role_favourites",
        requiredField: ["sequence", "form_code", "form_display", "form_uid", "label", "portal_code", "portal_display", "portal_uid",],
        required: [],
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "role_favourites",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "role_favourites",
        requiredField: ["sequence", "form_code", "form_display", "form_uid", "label", "portal_code", "portal_display", "portal_uid",]
      }, width: "col-sm-2"
    }),
    {
      tab: "role_favourites",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Sequence", field: "sequence" },
        { label: "Form Code", field: "form_code" },
        { label: "Form ", field: "form_display" },
        { label: "Label", field: "label" },
        { label: "Portal Code", field: "portal_code" },
        { label: "Portal ", field: "portal_display" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "role_favourites"
    },
    ...controls.displayText({ tab: "role_authentications", label: "Authentication Type", star: false }),
    ...controls.oc({ tab: "role_authentications", c: "AuthenticationType", placeHolder: "Authentication Type Code", name: "authentication_type_code", fastpath: "authentication_types", hidden: false }),
    ...controls.showData({ tab: "role_authentications", displaytype: "capital", data: "authentication_type_display" }),

    ...controls.displayText({ tab: "role_authentications", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "role_authentications", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "role_authentications",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "role_authentications",
        requiredField: ["authentication_type_code", "authentication_type_display", "authentication_type_uid",],
        required: [],
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "role_authentications",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "role_authentications",
        requiredField: ["authentication_type_code", "authentication_type_display", "authentication_type_uid",]
      }, width: "col-sm-2"
    }),
    {
      tab: "role_authentications",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Authentication Type Code", field: "authentication_type_code" },
        { label: "Authentication Type ", field: "authentication_type_display" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "role_authentications"
    },
    ...controls.displayText({ tab: "role_portals", label: "Portal", star: true }),
    ...controls.oc({ tab: "role_portals", c: "Portal", placeHolder: "Portal", name: "portal_code", fastpath: "portals", clearData: ['portal_scheme_code'], hidden: false }),
    ...controls.showData({ tab: "role_portals", displaytype: "capital", data: "portal_display" }),
    ...controls.displayText({ tab: "role_portals", label: "Portal Scheme", star: false }),
    ...controls.oc({ tab: "role_portals", c: "PortalScheme", placeHolder: "Portal Scheme Code", name: "portal_scheme_code", fastpath: "portal_schemes", autoopen: true, sendToServer: { sendData: [{ varname: 'portal_uid', value: 'portal_uid' }] }, hidden: false }),
    ...controls.showData({ tab: "role_portals", displaytype: "capital", data: "portal_scheme_display" }),

    ...controls.displayText({ tab: "role_portals", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "role_portals", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "role_portals",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "role_portals",
        requiredField: ["portal_code", "portal_display", "portal_uid", "portal_scheme_code", "portal_scheme_display", "portal_scheme_uid",],
        required: ["portal_code", "portal_display", "portal_uid",],
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "role_portals",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "role_portals",
        requiredField: ["portal_code", "portal_display", "portal_uid", "portal_scheme_code", "portal_scheme_display", "portal_scheme_uid",]
      }, width: "col-sm-2"
    }),
    {
      tab: "role_portals",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Portal Code", field: "portal_code" },
        { label: "Portal", field: "portal_display" },
        { label: "Portal Scheme Code", field: "portal_scheme_code" },
        { label: "Portal Scheme ", field: "portal_scheme_display" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "role_portals"
    },
    ...controls.displayText({ tab: "role_form_groups", label: "Form Group", star: false }),
    ...controls.oc({ tab: "role_form_groups", c: "FormGroup", placeHolder: "Form Group Code", name: "form_group_code", fastpath: "form_groups", hidden: false }),
    ...controls.showData({ tab: "role_form_groups", displaytype: "capital", data: "form_group_display" }),
    ...controls.displayText({ tab: "role_form_groups", label: "Label", star: false }),
    ...controls.text({ tab: "role_form_groups", placeHolder: "", name: "label", width: "col-sm-4", maxlength: 100 }),
    ...controls.displayText({ tab: "role_form_groups", label: "Portal", star: false }),
    ...controls.oc({ tab: "role_form_groups", c: "Portal", placeHolder: "Portal Code", name: "portal_code", fastpath: "portals", hidden: false }),
    ...controls.showData({ tab: "role_form_groups", displaytype: "capital", data: "portal_display" }),
    ...controls.displayText({ tab: "role_form_groups", label: "Form Type", star: false }),
    ...controls.autoComplete({ tab: "role_form_groups", name: "form_type_code", width: "col-sm-2", controlType: "FormType" }),
    ...controls.displayText({ tab: "role_form_groups", label: "" }),

    ...controls.displayText({ tab: "role_form_groups", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "role_form_groups", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "role_form_groups",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "role_form_groups",
        requiredField: ["form_group_code", "form_group_display", "form_group_uid", "label", "portal_code", "portal_display", "portal_uid", "form_type_code", "form_type_display", "form_type_uid",],
        required: [],
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "role_form_groups",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "role_form_groups",
        requiredField: ["form_group_code", "form_group_display", "form_group_uid", "label", "portal_code", "portal_display", "portal_uid", "form_type_code", "form_type_display", "form_type_uid",]
      }, width: "col-sm-2"
    }),
    {
      tab: "role_form_groups",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Form Group Code", field: "form_group_code" },
        { label: "Form Group ", field: "form_group_display" },
        { label: "Label", field: "label" },
        { label: "Portal Code", field: "portal_code" },
        { label: "Portal ", field: "portal_display" },
        { label: "Form Type Code", field: "form_type_code" },
        { label: "Form Type ", field: "form_type_display" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "role_form_groups"
    },
  ]
  , history: {
    perPage: 10,
    reportHeader: "Roles",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Role Code", accessor: "role_code", },
      { Header: "Role", accessor: "role_display", },
      { Header: "Role Level", accessor: "role_level", },
    ]
  }
};
export default roles;